// src/components/PrivateRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const LOCALSTORAGE_KEY = "isAdmin";

export default function PrivateRoute({ children }) {
  const isAdmin = typeof window !== "undefined" && localStorage.getItem(LOCALSTORAGE_KEY) === "true";
  const location = useLocation();

  if (!isAdmin) {
    return (
      <Navigate
        to={`/private/login?next=${encodeURIComponent(location.pathname + location.search)}`}
        replace
      />
    );
  }

  return children;
}
